import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"
import _imports_0 from '../../assets/imgs/headshots/adam-karp.jpg'


const _hoisted_1 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "Photo of Adam Karp"
}, null, -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("h2", null, "Adam Karp"),
  /*#__PURE__*/_createElementVNode("p", null, "Adam Karp was a Director at Bank of America Merrill Lynch within the Global Markets Equities division. As a member of the Prime Brokerage Sales and Coverage team, he was responsible for origination and relationship management across the EMEA region. Prior to joining Bank of America Merrill Lynch in 2016, Adam spent the previous 10 years at Credit Suisse, where he held numerous positions within the Prime Services business. Beginning in New York in 2006, as a hedge fund consultant, he was key in developing the operational and technology platform. In 2008 he relocated from New York to join the Prime Services Asia-Pacific team where he established the Prime Consulting, business consulting team regionally. In 2015 Adam relocated from Hong Kong to London, joining the Prime Services Coverage team. Prior to Credit Suisse, Adam worked at Eze Castle, a boutique technology consulting firm that focuses on the alternative investment management community.")
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_profile = _resolveComponent("profile")!

  return (_openBlock(), _createBlock(_component_profile, null, {
    headshot: _withCtx(() => [
      _hoisted_1
    ]),
    default: _withCtx(() => [
      _hoisted_2
    ]),
    _: 1
  }))
}